var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c("div", { staticClass: "floating-notification notification" }, [
        _c("button", { staticClass: "delete", on: { click: _vm.close } }),
        _c(
          "table",
          { staticClass: "table is-striped is-narrow floating-table" },
          [
            _c("thead", [
              _vm.title
                ? _c("tr", [
                    _c("th", { attrs: { colspan: "4" } }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c("tfoot", [
              _vm.totals != null
                ? _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Totals"),
                    ]),
                    _c(
                      "td",
                      { staticClass: "has-text-weight-bold has-text-right" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.totals,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm.totalExGst != null
                ? _c("tr", [
                    _c("td", { staticClass: "has-text-weight-bold" }, [
                      _vm._v("Grand Total"),
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "has-text-weight-bold has-text-right",
                        attrs: { colspan: "4" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatCurrency(
                              _vm.totalExGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("tbody", [
              _vm.rrTotal != null || _vm.cdTotal != null
                ? _c("tr", [
                    _vm.rrTotal != null ? _c("td", [_vm._v("R&R")]) : _vm._e(),
                    _vm.rrTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.rrTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.mechTotal != null
                      ? _c("td", [_vm._v("MECH")])
                      : _vm._e(),
                    _vm.mechTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.mechTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.repairTotal != null || _vm.cdTotal != null
                ? _c("tr", [
                    _vm.repairTotal != null
                      ? _c("td", [_vm._v("Repair")])
                      : _vm._e(),
                    _vm.repairTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.repairTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.cdTotal != null ? _c("td", [_vm._v("CD")]) : _vm._e(),
                    _vm.cdTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.cdTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.rwaTotal != null || _vm.cdTotal != null
                ? _c("tr", [
                    _vm.rwaTotal != null ? _c("td", [_vm._v("RWA")]) : _vm._e(),
                    _vm.rwaTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.rwaTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.crushTotal != null
                      ? _c("td", [_vm._v("CRUSH")])
                      : _vm._e(),
                    _vm.crushTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.crushTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.paintTotal != null || _vm.cdTotal != null
                ? _c("tr", [
                    _vm.paintTotal != null
                      ? _c("td", [_vm._v("Paint")])
                      : _vm._e(),
                    _vm.paintTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.paintTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.fgTotal != null
                      ? _c("td", [_vm._v("FIBER")])
                      : _vm._e(),
                    _vm.fgTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.fgTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.partTotal != null || _vm.cdTotal != null
                ? _c("tr", [
                    _vm.partTotal != null
                      ? _c("td", [_vm._v("Part")])
                      : _vm._e(),
                    _vm.partTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.partTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                    _vm.opgTotal != null ? _c("td", [_vm._v("OPG")]) : _vm._e(),
                    _vm.opgTotal != null
                      ? _c("td", { staticClass: "has-text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.opgTotal,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }